import angularModule from 'Lessons/angularModule/scripts/lessons_module';
import 'Editor/bootstrapCollapseShim';

angularModule.directive('frameExpandPanelInitially', [
    '$injector',
    function factory() {
        return {
            restrict: 'A',
            link(scope, elem) {
                if (scope.frameViewModel.frame.$$expandExtraPanelsInitially) {
                    elem.collapse('show');
                }
            },
        };
    },
]);
